(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mx-accordion"] && !Shopify.designMode) return;
  try {
    (function () {
    /*
      <details> opens and shuts in one frame. The click is caught here and the answer's height is
      slid between 0 and its own size instead, with a fade. Without this script, or with reduced
      motion asked for, the rows still open and close the plain way.
    */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    /*
      Opening eases out: it moves at once and settles. Closing eases in and out: an ease out on
      the way shut drops most of the height in the first frames and reads as a snap, so the
      close starts gently, and the text keeps most of its opacity until the row is nearly shut.
    */
    var easeOpen = 'cubic-bezier(0.33, 1, 0.68, 1)';
    var easeClose = 'cubic-bezier(0.65, 0, 0.35, 1)';

    function slide(row, open) {
      var body = row.querySelector('.mx-ac__body');
      if (!body || !body.animate || (reduce && reduce.matches)) {
        row.open = open;
        return;
      }

      /*
        The whole row is what slides, between its open height and the height of its head alone.
        Sliding the answer box instead stalled 28 short of shut, because its own padding cannot
        squeeze below that, and the last of it then dropped in one go after the slide.
      */
      // a click mid slide starts from wherever the row has got to
      var from = row.getBoundingClientRect().height;
      var fromOpacity = row.open ? parseFloat(getComputedStyle(body).opacity) : 0;
      if (row._mxAcAnim) {
        row._mxAcAnim.cancel();
        row._mxAcFade.cancel();
      }

      var to;
      if (open) {
        row.classList.remove('is-closing');
        row.open = true;
        to = row.getBoundingClientRect().height;
      } else {
        row.classList.add('is-closing');
        to = row.getBoundingClientRect().height - body.getBoundingClientRect().height;
      }

      function done() {
        row._mxAcAnim = null;
        if (!open) {
          row.open = false;
          row.classList.remove('is-closing');
        }
        row.style.overflow = '';
        row.style.boxSizing = '';
        rowAnim.cancel();
        fade.cancel();
      }

      // the time follows the distance, so a short answer is not slow and a long one not rushed
      var duration = Math.min(560, Math.max(300, Math.abs(to - from) * 1.2));
      var easing = open ? easeOpen : easeClose;

      row.style.overflow = 'hidden';
      row.style.boxSizing = 'border-box';

      /*
        fill: forwards holds the last frame until done() has run, so the row never shows its
        full height for a frame before it shuts.
      */
      var rowAnim = row.animate([{ height: from + 'px' }, { height: to + 'px' }], {
        duration: duration,
        easing: easing,
        fill: 'forwards',
      });

      // the text fades out a little ahead of the slide on the way shut, and in behind it on open
      var fade = body.animate([{ opacity: fromOpacity }, { opacity: open ? 1 : 0 }], {
        duration: open ? duration : duration * 0.75,
        easing: 'ease',
        fill: 'forwards',
      });

      row._mxAcAnim = rowAnim;
      row._mxAcFade = fade;
      rowAnim.onfinish = done;
    }

    function init(root) {
      if (root.dataset.mxAcReady === 'true') return;
      root.dataset.mxAcReady = 'true';

      root.addEventListener('click', function (event) {
        var head = event.target.closest('.mx-ac__head');
        if (!head || !root.contains(head)) return;
        var row = head.parentElement;

        event.preventDefault();
        slide(row, !row.open || row.classList.contains('is-closing'));
      });
    }

    function boot() {
      var roots = document.querySelectorAll('.mx-ac');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mx-atc"] && !Shopify.designMode) return;
  try {
    (function () {
    /*
      Figma writes the price of the chosen pack on the add to cart button. Rather than work the
      price out a second time, the button copies whatever the price block is showing, so it
      follows the variant through the theme's own logic and can never disagree with it.
    */
    function priceIn(product) {
      var el = product.querySelector(
        '.pdp-price #main-price, .pdp-price .price-item--sale, .pdp-price .price__regular .price-item--regular'
      );
      return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    function paint(product, slot) {
      var button = slot.parentNode;
      var text = priceIn(product);
      // a sold out button says so on its own, a price next to it would only confuse
      slot.textContent = button.disabled || !text ? '' : '| ' + text;
    }

    function init(product) {
      if (product.dataset.mxAtcReady === 'true') return;

      var button = product.querySelector('.product-form-cta .product-form__submit');
      var price = product.querySelector('.pdp-price');
      if (!button || !price) return;
      product.dataset.mxAtcReady = 'true';

      var slot = button.querySelector('.mx-atc__price');
      if (!slot) {
        slot = document.createElement('span');
        slot.className = 'mx-atc__price';
        button.appendChild(slot);
      }

      // the price block is rewritten on every variant change, whichever script does it
      if (window.MutationObserver) {
        new MutationObserver(function () {
          paint(product, slot);
        }).observe(price, { childList: true, subtree: true, characterData: true });

        new MutationObserver(function () {
          paint(product, slot);
        }).observe(button, { attributes: true, attributeFilter: ['disabled'] });
      }

      paint(product, slot);
    }

    function boot() {
      var products = document.querySelectorAll('.product.mx-pdp');
      for (var i = 0; i < products.length; i++) init(products[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mx-fbt"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      if (root.dataset.mxFbtReady === 'true') return;
      root.dataset.mxFbtReady = 'true';

      var button = root.querySelector('[data-mx-fbt-add]');
      if (!button) return;

      // every product sold out: the button stays disabled and says so (Liquid)
      if (root.hasAttribute('data-mx-fbt-sold-out')) return;

      // ticking or unticking a card re-adds the total and the button state
      root.addEventListener('change', function (event) {
        if (event.target.classList.contains('mx-fbt__input')) sync();
      });

      function picked() {
        var out = [];
        var boxes = root.querySelectorAll('.mx-fbt__input');
        for (var i = 0; i < boxes.length; i++) {
          // a sold out card is disabled, so it can never end up in here
          if (boxes[i].checked && !boxes[i].disabled) out.push({ id: boxes[i].value, quantity: 1 });
        }
        return out;
      }

      var totalEl = root.querySelector('[data-mx-fbt-total]');
      var format = root.dataset.mxFbtMoney || '{{amount}}';

      // the shop's money format, with the trailing zeros dropped the way Liquid's
      // money_without_trailing_zeros does, so the button reads the same as the cards
      function money(cents) {
        return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (all, kind) {
          var swapped = kind.indexOf('comma_separator') > -1;
          var decimals = kind.indexOf('no_decimals') > -1 || cents % 100 === 0 ? 0 : 2;
          var text = (cents / 100).toFixed(decimals);
          var bits = text.split('.');
          bits[0] = bits[0].replace(/\B(?=(\d{3})+(?!\d))/g, swapped ? '.' : ',');
          return bits.length > 1 ? bits[0] + (swapped ? ',' : '.') + bits[1] : bits[0];
        });
      }

      function sync() {
        var boxes = root.querySelectorAll('.mx-fbt__input');
        var now = 0;
        var was = 0;
        var chosen = 0;

        for (var i = 0; i < boxes.length; i++) {
          if (!boxes[i].checked || boxes[i].disabled) continue;
          chosen += 1;
          now += parseInt(boxes[i].dataset.mxFbtPrice, 10) || 0;
          was += parseInt(boxes[i].dataset.mxFbtCompare, 10) || 0;
        }

        button.disabled = chosen === 0;
        if (!totalEl) return;

        /*
          % off from the product metafields: the "all" one when the whole set is ticked (a sold
          out product counts as not ticked), the "two" one when exactly two are. A set of two
          uses the "all" one. Rounded to whole rupees.
        */
        var off = 0;
        if (chosen > 1 && chosen === boxes.length) off = parseFloat(root.dataset.mxFbtOffAll) || 0;
        else if (chosen === 2) off = parseFloat(root.dataset.mxFbtOffTwo) || 0;
        if (off > 0) {
          was = Math.max(was, now);
          now = Math.round((now * (100 - off)) / 100 / 100) * 100;
        }

        totalEl.textContent = chosen ? '| ' + money(now) : '';
        if (chosen && was > now) {
          var struck = document.createElement('s');
          struck.className = 'mx-fbt__add-was';
          struck.textContent = money(was);
          totalEl.appendChild(document.createTextNode(' '));
          totalEl.appendChild(struck);
        }
      }

      sync();

      /*
        The first card is this page's own product. When another variant is chosen on the page (pack size picker, the
        theme's variant radios, ?variant=) its tick, price and stock follow it. Same source as the SIZE line: the product
        form's hidden input[name="id"].
      */
      var mainBox = root.querySelector('[data-mx-fbt-main] .mx-fbt__input');
      var mapEl = root.querySelector('[data-mx-fbt-map]');
      var variantMap = null;
      try { variantMap = mapEl ? JSON.parse(mapEl.textContent) : null; } catch (e) { variantMap = null; }

      function followVariant() {
        if (!mainBox || !variantMap) return;
        var scope = root.closest('.product') || document;
        var input = scope.querySelector('form[action*="/cart/add"] input[name="id"]') ||
          document.querySelector('form[action*="/cart/add"] input[name="id"]');
        var id = String((input && input.value) || new URLSearchParams(location.search).get('variant') || '');
        var v = variantMap[id];
        if (!v || mainBox.value === id) return;

        var card = mainBox.closest('.mx-fbt__card');
        mainBox.value = id;
        mainBox.dataset.mxFbtPrice = v.price;
        mainBox.dataset.mxFbtCompare = v.compare;

        var priceEl = card.querySelector('.mx-fbt__price');
        var nowEl = card.querySelector('.mx-fbt__price-now');
        var wasEl = card.querySelector('.mx-fbt__price-was');
        if (nowEl) nowEl.textContent = money(v.price);
        if (v.compare > v.price) {
          if (!wasEl && priceEl) {
            wasEl = document.createElement('s');
            wasEl.className = 'mx-fbt__price-was';
            priceEl.appendChild(wasEl);
          }
          if (wasEl) wasEl.textContent = money(v.compare);
        } else if (wasEl) {
          wasEl.remove();
        }

        mainBox.disabled = !v.available;
        mainBox.checked = !!v.available;
        card.classList.toggle('mx-fbt__card--out', !v.available);
        sync();
      }

      function followLater() {
        // the theme writes the new variant id a moment after the click
        followVariant();
        setTimeout(followVariant, 150);
        setTimeout(followVariant, 500);
      }

      document.addEventListener('change', function (e) {
        if (!root.contains(e.target)) followLater();
      });
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.pack-size-slide, variant-radios, variant-selects, .product_pills')) followLater();
      });
      followVariant();

      button.addEventListener('click', function () {
        var items = picked();
        if (!items.length) return;

        button.disabled = true;
        var drawer = document.querySelector('cart-drawer');
        var body = { items: items };
        if (drawer) {
          body.sections = ['cart-drawer', 'cart-icon-bubble'];
          body.sections_url = window.location.pathname;
        }

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(body),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (state) {
            if (drawer && state && state.sections) {
              drawer.renderContents(state);
            } else {
              window.location.reload();
            }
          })
          .catch(function () {
            // the cart is the honest fallback when the drawer cannot be refreshed here
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          })
          .finally(function () {
            // sync puts the button's state and its running total back
            sync();
          });
      });
    }

    function boot() {
      var roots = document.querySelectorAll('.mx-fbt');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mx-gallery"] && !Shopify.designMode) return;
  try {
    /* Gallery Design 2: up / down arrows scroll the theme's thumbnail list; the active thumbnail is kept in view */
(function () {
  function init(gallery) {
    if (gallery.dataset.mxGalReady) return;
    gallery.dataset.mxGalReady = 'true';

    var list = gallery.querySelector('.thumbnail-list');
    var up = gallery.querySelector('[data-mx-gal-up]');
    var down = gallery.querySelector('[data-mx-gal-down]');
    if (!list || !up || !down) return;

    function step() {
      var item = list.querySelector('.thumbnail-list__item');
      return item ? item.offsetHeight + 6.22 : 80;
    }
    function updateArrows() {
      up.disabled = list.scrollTop <= 1;
      down.disabled = list.scrollTop + list.clientHeight >= list.scrollHeight - 1;
    }
    up.addEventListener('click', function () { list.scrollBy({ top: -step() }); });
    down.addEventListener('click', function () { list.scrollBy({ top: step() }); });
    list.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    /* Variant change / thumbnail click: bring the current thumbnail into view (the theme scrolls sideways only) */
    new MutationObserver(function () {
      var current = list.querySelector('.thumbnail[aria-current]');
      if (!current) return;
      var item = current.closest('.thumbnail-list__item') || current;
      if (item.offsetTop < list.scrollTop || item.offsetTop + item.offsetHeight > list.scrollTop + list.clientHeight) {
        list.scrollTo({ top: item.offsetTop });
      }
    }).observe(list, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mx-gal]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mx-hero-top"] && !Shopify.designMode) return;
  try {
    (function () {
    /*
      Nothing is moved here. Figma puts this block above the gallery on mobile and inside the
      right column on desktop, and the section renders it in both places, each one hidden at the
      breakpoint it does not belong to. Moving it with script meant the page first painted it in
      the wrong place and then jumped.
    */

    // Manifest AI chat; its app embed may still be loading on an early click, so it is tried for a few seconds
    function openChat(tries) {
      if (window.bik_widget && typeof window.bik_widget.open === 'function') {
        window.bik_widget.open();
      } else if (tries > 0) {
        setTimeout(function () {
          openChat(tries - 1);
        }, 300);
      }
    }

    // REVIEW SUMMARY: the link from the block when "Link below" is chosen (data-href), otherwise the chat
    document.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('[data-mx-ht-summary]') : null;
      if (!button) return;
      var root = button.closest('.mx-ht');
      if (root) root.dispatchEvent(new CustomEvent('mx:review-summary', { bubbles: true }));

      var href = button.getAttribute('data-href');
      if (href) {
        window.location.href = href;
        return;
      }
      openChat(10);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mx-layout"] && !Shopify.designMode) return;
  try {
    (function () {
    /*
      Figma puts Results from users and the accordion under the add to bag row, but the theme
      renders that row outside the block list, so no block can reach it on its own. The blocks
      mark themselves with data-mx-ly-after-atc and are moved here, all from one place, so they
      keep the order the merchant set in the customizer however the scripts happen to run.
    */
    function place(product) {
      var form = product.querySelector('.product-form_wrapper');
      if (!form) return;

      var blocks = product.querySelectorAll('[data-mx-ly-after-atc]');
      var anchor = form;
      for (var i = 0; i < blocks.length; i++) {
        if (anchor.nextElementSibling !== blocks[i]) {
          anchor.parentNode.insertBefore(blocks[i], anchor.nextSibling);
        }
        anchor = blocks[i];
      }
    }

    function boot() {
      var products = document.querySelectorAll('.product.mx-pdp');
      for (var i = 0; i < products.length; i++) place(products[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mx-offers"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      if (root.dataset.mxOfReady === 'true') return;
      root.dataset.mxOfReady = 'true';

      function onCopyClick(event) {
        var copy = event.target.closest('[data-mx-of-copy]');
        if (copy) {
          var code = copy.dataset.mxOfCopy;
          var label = copy.querySelector('.mx-of__code-text');
          if (!label) return;

          var done = function () {
            if (copy.dataset.mxOfCopied) return;
            var was = label.textContent;
            copy.dataset.mxOfCopied = 'true';
            label.textContent = 'Copied';
            setTimeout(function () {
              label.textContent = was;
              delete copy.dataset.mxOfCopied;
            }, 1600);
          };

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(done, function () {});
          } else {
            // older browsers, and any page not served over https
            var field = document.createElement('textarea');
            field.value = code;
            field.setAttribute('readonly', '');
            field.style.position = 'absolute';
            field.style.left = '-9999px';
            document.body.appendChild(field);
            field.select();
            try {
              document.execCommand('copy');
              done();
            } catch (e) {
              /* nothing to do, the code is on screen to read */
            }
            document.body.removeChild(field);
          }
        }
      }

      root.addEventListener('click', onCopyClick);

      /* View all popup: moved to <body> so a transformed parent cannot trap position: fixed */
      var popup = root.querySelector('[data-mx-of-popup]');
      var openBtn = root.querySelector('[data-mx-of-open]');
      if (!popup || !openBtn) return;

      var old = document.getElementById(popup.id);
      if (old && old !== popup && old.parentNode === document.body) old.parentNode.removeChild(old);
      document.body.appendChild(popup);
      popup.addEventListener('click', onCopyClick);

      var card = popup.querySelector('[data-mx-of-popup-card]');
      var closeBtn = popup.querySelector('[data-mx-of-close]');

      function openPopup() {
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        openBtn.setAttribute('aria-expanded', 'true');
        /*
          Page scroll is locked only for the mobile drawer. Locking it on desktop changes the scroll
          container, and the sticky gallery jumped out of view behind the popup.
        */
        if (window.matchMedia('(max-width: 749px)').matches) document.documentElement.style.overflow = 'hidden';
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      }

      function closePopup() {
        if (!popup.classList.contains('is-open')) return;
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        openBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        openBtn.focus({ preventScroll: true });
      }

      openBtn.addEventListener('click', openPopup);
      if (closeBtn) closeBtn.addEventListener('click', closePopup);
      popup.addEventListener('click', function (e) {
        if (card && !card.contains(e.target)) closePopup();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closePopup();
      });
    }

    function boot() {
      var roots = document.querySelectorAll('.mx-of');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mx-results"] && !Shopify.designMode) return;
  try {
    (function () {
    // one pair plus the gap, read off the rendered row so nothing is hardcoded
    function stepOf(track) {
      var card = track.firstElementChild;
      if (!card) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap);
      if (isNaN(gap)) gap = 0;
      return card.getBoundingClientRect().width + gap;
    }

    // the arrows are worth showing only when the row is wider than the space it has
    function syncNav(track, nav) {
      if (!nav) return;
      nav.hidden = track.scrollWidth - track.clientWidth <= 1;
    }

    function init(root) {
      if (root.dataset.mxRsReady === 'true') return;
      root.dataset.mxRsReady = 'true';

      var track = root.querySelector('.mx-rs__track');
      if (!track) return;
      var nav = root.querySelector('.mx-rs__nav');

      var arrows = root.querySelectorAll('[data-mx-rs-step]');
      for (var i = 0; i < arrows.length; i++) {
        arrows[i].addEventListener('click', function (event) {
          var dir = parseInt(event.currentTarget.dataset.mxRsStep, 10) || 1;
          track.scrollBy({ left: stepOf(track) * dir, behavior: 'smooth' });
        });
      }

      syncNav(track, nav);

      // the column is a different width on every breakpoint, and the images settle after load
      if (window.ResizeObserver) {
        new ResizeObserver(function () {
          syncNav(track, nav);
        }).observe(track);
      } else {
        window.addEventListener('resize', function () {
          syncNav(track, nav);
        });
      }
      window.addEventListener('load', function () {
        syncNav(track, nav);
      });
    }

    function boot() {
      var roots = document.querySelectorAll('.mx-rs');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mx-size"] && !Shopify.designMode) return;
  try {
    (function () {
    /*
      Follows the variant the theme has chosen: the product form's hidden input[name="id"] holds it.
      The pack size picker, the theme's variant radios and the URL (?variant=) all change it, so it is
      read again after any change inside the product and on history navigation.
    */
    function update(root) {
      var product = root.closest('.product') || document;
      var form = product.querySelector('form[action*="/cart/add"] input[name="id"]') ||
        document.querySelector('form[action*="/cart/add"] input[name="id"]');
      var mapEl = document.querySelector('[data-mx-sz-map="' + root.id + '"]');
      var valueEl = root.querySelector('[data-mx-sz-value]');
      if (!form || !mapEl || !valueEl) return;

      var map;
      try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }

      var id = String(form.value || new URLSearchParams(location.search).get('variant') || '');
      var size = map[id];
      if (size === undefined) return;

      if (valueEl.textContent !== size) valueEl.textContent = size;
      root.hidden = !size;
    }

    function all() {
      var roots = document.querySelectorAll('[data-mx-sz]');
      for (var i = 0; i < roots.length; i++) update(roots[i]);
    }

    function later() {
      // the theme writes the new variant id a moment after the click
      all();
      setTimeout(all, 150);
      setTimeout(all, 500);
    }

    document.addEventListener('change', later);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.pack-size-slide, variant-radios, variant-selects, .product_pills')) later();
    });
    window.addEventListener('popstate', later);
    document.addEventListener('shopify:section:load', later);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', all);
    } else {
      all();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mx-variant-tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    // Buy Once is the only working tab for now. Subscribe + Save only announces itself.
    document.addEventListener('click', function (event) {
      var tab = event.target.closest ? event.target.closest('[data-mx-vt-tab]') : null;
      if (!tab) return;

      var root = tab.closest('.mx-vt');
      if (!root) return;

      if (tab.dataset.mxVtTab === 'subscribe') {
        root.dispatchEvent(new CustomEvent('mx:subscribe-tab', { bubbles: true }));
        return;
      }

      var tabs = root.querySelectorAll('[data-mx-vt-tab]');
      for (var i = 0; i < tabs.length; i++) {
        var on = tabs[i] === tab;
        tabs[i].classList.toggle('mx-vt__tab--on', on);
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
